(function () {

  console.log('MADSPEED7 — Universal Candy Rack system loading...');

  /* =========================================================
     CONFIG
  ========================================================= */

  const OFFER_SELECTOR =
    '.candyrack-ppp-checkbox-layout__offer';

  const CHECKBOX_SELECTOR =
    '.styles_checkboxInput__1b8f7wn7';

  const SELECTOR_SELECTOR =
    '.candyrack-ppp-select-input';

  const PRODUCT_NAME_SELECTOR =
    '.candyrack-ppp-checkbox-layout__info--product-name';

  const INPUTS_WRAPPER_SELECTOR =
    '.styles_offerInputsWrapper__107pldjx';

    /* =========================================================
   MADSPEED7 — CACHE SHOPIFY PRODUCTS
   Load product data once in the background
========================================================= */

window.madspeed7ProductsPromise =
  fetch(
    '/products.json?limit=250'
  )
    .then(
      function (response) {

        if (!response.ok) {
          throw new Error(
            'Shopify product lookup failed: HTTP ' +
            response.status
          );
        }

        return response.json();

      }
    )
    .catch(
      function (error) {

        console.error(
          'MADSPEED7 — Product cache failed:',
          error
        );

        throw error;

      }
    );


  /* =========================================================
     1. HIDE CANDY RACK CHECKBOX GRAPHICS
  ========================================================= */

  function hideCheckboxGraphics() {

    document.querySelectorAll(
      '.styles_checkboxWrapperNormal__1b8f7wn2'
    ).forEach(function (element) {

      element.style.setProperty(
        'display',
        'none',
        'important'
      );

    });


    document.querySelectorAll(
      '.styles_checkboxWrapperArea__1b8f7wn1'
    ).forEach(function (element) {

      element.style.setProperty(
        'opacity',
        '0',
        'important'
      );

    });

  }


  /* =========================================================
     2. GET OFFER QUANTITY
  ========================================================= */

  function getQuantity(offer) {

  const quantityElement =
    offer.querySelector(
      '.madspeed7-addon-qty-value'
    );

  if (!quantityElement) {
    return 1;
  }

  const value =
    parseInt(
      quantityElement.textContent,
      10
    );

  return Number.isFinite(value) && value > 0
    ? value
    : 1;
}

function getQuantityFromOfferControl(offer) {

  const wrapper =
    offer.querySelector(
      '.madspeed7-addon-quantity'
    );

  if (!wrapper) {
    return 1;
  }

  return parseInt(
    wrapper.dataset.quantity || '1',
    10
  ) || 1;
}

function layoutActionRow(offer) {
  const inputsWrapper = offer.querySelector(INPUTS_WRAPPER_SELECTOR);
  if (!inputsWrapper) return;

  const qty = offer.querySelector('.madspeed7-addon-quantity');
  const button = offer.querySelector('.madspeed7-add-item-button');
  if (!qty || !button) return;

  let row = offer.querySelector('.madspeed7-addon-action-row');
  if (!row) {
    row = document.createElement('div');
    row.className = 'madspeed7-addon-action-row';
    inputsWrapper.appendChild(row);
  }

  if (qty.parentElement !== row) row.appendChild(qty);
  if (button.parentElement !== row) row.appendChild(button);
}


  /* =========================================================
     3. CREATE CUSTOM QUANTITY CONTROL
  ========================================================= */

  function createQuantityControl(offer) {

    if (
      offer.querySelector(
        '.madspeed7-addon-quantity'
      )
    ) {
      return;
    }


    const wrapper =
      document.createElement('div');

    wrapper.className =
      'madspeed7-addon-quantity';


    const minus =
      document.createElement('button');

    minus.type = 'button';

    minus.className =
      'madspeed7-addon-qty-minus';

    minus.setAttribute(
      'aria-label',
      'Decrease quantity'
    );


    const value =
      document.createElement('span');

    value.className =
      'madspeed7-addon-qty-value';

    value.textContent = '1';


    const plus =
      document.createElement('button');

    plus.type = 'button';

    plus.className =
      'madspeed7-addon-qty-plus';

    plus.setAttribute(
      'aria-label',
      'Increase quantity'
    );


    wrapper.appendChild(minus);
    wrapper.appendChild(value);
    wrapper.appendChild(plus);


    const inputsWrapper =
      offer.querySelector(
        INPUTS_WRAPPER_SELECTOR
      );

    if (inputsWrapper) {

      inputsWrapper.appendChild(
        wrapper
      );

    } else {

      const info =
        offer.querySelector(
          '.candyrack-ppp-checkbox-layout__info'
        );

      if (info) {
        info.appendChild(wrapper);
      }

    }


    function updateQuantity(newQuantity) {

      newQuantity =
        Math.max(
          1,
          parseInt(newQuantity, 10) || 1
        );


      value.textContent =
        newQuantity;


      minus.disabled =
        newQuantity <= 1;


      wrapper.dataset.quantity =
        newQuantity;

        const button =
  offer.querySelector(
    '.madspeed7-add-item-button'
  );

if (
  button &&
  button.dataset.madspeed7Added ===
    'true'
) {

  button.dataset.madspeed7Quantity =
    String(newQuantity);
}


      console.log(
        'MADSPEED7 — Quantity changed:',
        newQuantity
      );

    }


    minus.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        const current =
          getQuantityFromControl();

        updateQuantity(
          current - 1
        );

      }
    );


    plus.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        const current =
          getQuantityFromControl();

        updateQuantity(
          current + 1
        );

      }
    );


    function getQuantityFromControl() {

      return parseInt(
        wrapper.dataset.quantity || '1',
        10
      ) || 1;

    }


    wrapper.dataset.quantity = '1';

    updateQuantity(1);

  }


  /* =========================================================
     4. GET CANDY RACK PRODUCT ID
  ========================================================= */

  function getCandyRackProductId(offer) {

    const match =
      offer.className.match(
        /candyrack-ppp-product-id-(\d+)/
      );

    if (!match) {
      return null;
    }

    return match[1];

  }


  /* =========================================================
     5. GET SELECTED VARIANT
  ========================================================= */

  function getSelectedVariantId(offer) {

    const select =
      offer.querySelector(
        SELECTOR_SELECTOR
      );

    if (!select) {
      return null;
    }


    const value =
      select.value;


    if (
      !value ||
      value === '__cr_select_option__'
    ) {
      return null;
    }


    return value;

  }

/* =========================================================
   5A. VARIANT PRICING
========================================================= */

async function setupVariantPricing(offer) {

  const select =
    offer.querySelector(
      SELECTOR_SELECTOR
    );

  const priceElement =
    offer.querySelector(
      '.candyrack-ppp-checkbox-layout__info--product-price'
    );

    if (priceElement) {
  priceElement.style.setProperty(
    'margin-top',
    '12px',
    'important'
  );
}

  if (
    !select ||
    !priceElement
  ) {
    return;
  }

  const currency =
    priceElement.querySelector(
      '.candyrack-ppp-currency-output'
    );

  if (!currency) {
    return;
  }

  const productId =
    getCandyRackProductId(offer);

  if (!productId) {
    return;
  }

  try {

    const data =
  await window.madspeed7ProductsPromise;

    const product =
      (data.products || []).find(
        function (item) {

          return String(item.id) ===
            String(productId);

        }
      );

    if (!product) {
      return;
    }

    const variantPrices = {};

    product.variants.forEach(
      function (variant) {

        variantPrices[
          String(variant.id)
        ] =
          parseFloat(
            variant.price
          );

      }
    );

    const prices =
      product.variants
        .map(
          function (variant) {

            return parseFloat(
              variant.price
            );

          }
        )
        .filter(
          function (price) {

            return Number.isFinite(
              price
            );

          }
        );

    if (!prices.length) {
      return;
    }

    const lowestPrice =
      Math.min.apply(
        null,
        prices
      );


    function updatePrice() {

      const value =
        String(
          select.value
        );


      /*
       * No variant selected:
       * show the lowest price with "From".
       */

      if (
        value ===
        '__cr_select_option__'
      ) {

        currency.textContent =
  '£' +
  lowestPrice.toFixed(2);

        return;
      }


      /*
       * Variant selected:
       * show that variant's actual price.
       */

      const variantPrice =
        variantPrices[value];

      if (
        variantPrice === undefined
      ) {
        return;
      }

      currency.textContent =
        '£' +
        variantPrice.toFixed(2);
    }


    /*
     * Set the initial price.
     */

    updatePrice();


    /*
     * Update whenever the customer
     * changes the variant.
     */

    if (
      offer.dataset.madspeed7PricingBound !==
      'true'
    ) {

      select.addEventListener(
        'change',
        function () {

          updatePrice();

          /*
           * Candy Rack can update its
           * own price asynchronously.
           * Refresh again afterwards.
           */

          setTimeout(
            updatePrice,
            100
          );

          setTimeout(
            updatePrice,
            300
          );

          setTimeout(
            updatePrice,
            600
          );

        }
      );

      offer.dataset.madspeed7PricingBound =
        'true';
    }

  } catch (error) {

    console.error(
      'MADSPEED7 — Variant pricing failed:',
      error
    );

  }

}

/* =========================================================
   MADSPEED7 — CREATE QUICK VIEW LINK
========================================================= */

function createQuickViewLink(offer) {

  const title =
    offer.querySelector(
      PRODUCT_NAME_SELECTOR
    );

  const price =
    offer.querySelector(
      '.candyrack-ppp-checkbox-layout__info--product-price'
    );

  if (!title || !price) {
    return;
  }

  if (
    offer.querySelector(
      '.madspeed7-quick-view'
    )
  ) {
    return;
  }

  const link =
    document.createElement(
      'button'
    );

  link.type =
    'button';

  link.className =
    'madspeed7-quick-view';

  link.textContent =
    'Quick view';

  title.parentElement.insertAdjacentElement(
  'afterend',
  link
);

}

  /* =========================================================
   6. REQUIRE VARIANT SELECTION
========================================================= */

function setupVariantRequirement(offer) {

  const button =
    offer.querySelector(
      '.madspeed7-add-item-button'
    );

  if (!button) {
    return;
  }


  function getCurrentSelect() {
    return offer.querySelector(
      SELECTOR_SELECTOR
    );
  }


  function updateButtonState() {

    const select =
      getCurrentSelect();

    if (!select) {
      return;
    }

    const hasVariant =
      !!select.value &&
      select.value !==
        '__cr_select_option__';

        offer.classList.toggle(
  'madspeed7-show-from',
  !hasVariant
);

    button.disabled =
      !hasVariant;

    if (hasVariant) {

      button.style.opacity =
        '';

      button.style.cursor =
        'pointer';

      if (
        button.dataset.madspeed7Added !==
        'true'
      ) {

        button.style.background =
          '#ffffff';

        button.style.color =
          '#222222';

        button.style.borderColor =
          '#222222';
      }

    } else {

      button.disabled =
        true;

      button.style.opacity =
        '0.45';

      button.style.cursor =
        'not-allowed';

      button.style.background =
        '#eeeeee';

      button.style.color =
        '#888888';

      button.style.borderColor =
        '#cccccc';
    }
  }


  function ensurePlaceholder() {

    const select =
      getCurrentSelect();

    if (!select) {
      return;
    }

    let placeholder =
      select.querySelector(
        'option[data-madspeed7-placeholder="true"]'
      );

    if (!placeholder) {

      placeholder =
        document.createElement('option');

      placeholder.value =
        '__cr_select_option__';

      placeholder.textContent =
        'Select option';

      placeholder.disabled =
        true;

      placeholder.setAttribute(
        'data-madspeed7-placeholder',
        'true'
      );

      select.insertBefore(
        placeholder,
        select.firstChild
      );
    }

    /*
     * Only set the initial state once.
     * Do not keep forcing it back after
     * the customer makes a selection.
     */

    if (
      !offer.dataset.madspeed7VariantInitialised
    ) {

      select.value =
        '__cr_select_option__';

      select.selectedIndex =
        0;

      const handleLabel =
        offer.querySelector(
          '.styles_selectHandleLabel__7a9ea26'
        );

      if (handleLabel) {

        handleLabel.textContent =
          'Select option';
      }

      offer.dataset.madspeed7VariantInitialised =
        'true';
    }
  }


  /*
   * Initial setup.
   */

  ensurePlaceholder();
  updateButtonState();


  /*
   * Watch for the customer's selection.
   *
   * We use a delegated listener because Candy Rack
   * can replace the select element during rendering.
   */

  if (
    offer.dataset.madspeed7VariantListener !==
    'true'
  ) {

    document.addEventListener(
  'change',
  function (event) {

    const currentSelect =
      offer.querySelector(
        SELECTOR_SELECTOR
      );

    if (
      !currentSelect ||
      event.target !== currentSelect
    ) {
      return;
    }

    const selectedOption =
      currentSelect.options[
        currentSelect.selectedIndex
      ];

    const handleLabel =
      offer.querySelector(
        '.styles_selectHandleLabel__7a9ea26'
      );

    if (
      handleLabel &&
      selectedOption
    ) {

      handleLabel.textContent =
        selectedOption.textContent;
    }

    updateButtonState();
  },
  true
);

    offer.dataset.madspeed7VariantListener =
      'true';
  }


  /*
   * Candy Rack can re-render the offer.
   * Make sure the placeholder still exists,
   * but never reset a customer's selection.
   */

  if (
    offer.dataset.madspeed7VariantObserver !==
    'true'
  ) {

    const observer =
      new MutationObserver(
        function () {

          ensurePlaceholder();
          updateButtonState();

        }
      );

    observer.observe(
      offer,
      {
        childList: true,
        subtree: true
      }
    );

    offer.dataset.madspeed7VariantObserver =
      'true';
  }

}
  


  /* =========================================================
     6. FIND DEFAULT VARIANT FROM PRODUCT
  ========================================================= */

  async function getDefaultVariantId(productId) {

  try {

    console.log(
      'MADSPEED7 — Looking up no-variant product:',
      productId
    );

    const data =
      await window.madspeed7ProductsPromise;

    const product =
      (data.products || []).find(
        function (item) {

          return String(item.id) ===
            String(productId);

        }
      );

    if (!product) {

      console.error(
        'MADSPEED7 — Product NOT found:',
        productId
      );

      return null;
    }

    console.log(
      'MADSPEED7 — No-variant product found:',
      product.title
    );

    const availableVariant =
      product.variants.find(
        function (variant) {

          return variant.available;

        }
      );

    if (availableVariant) {

      console.log(
        'MADSPEED7 — Using available default variant:',
        availableVariant.id
      );

      return String(
        availableVariant.id
      );

    }

    if (
      product.variants &&
      product.variants.length
    ) {

      console.log(
        'MADSPEED7 — Using first Shopify variant:',
        product.variants[0].id
      );

      return String(
        product.variants[0].id
      );

    }

    console.error(
      'MADSPEED7 — Product has no Shopify variants:',
      productId
    );

    return null;

  } catch (error) {

    console.error(
      'MADSPEED7 — Product lookup error:',
      error
    );

    return null;

  }

}
  


  function createAddItemButton(offer) {

  const checkbox =
    offer.querySelector(
      CHECKBOX_SELECTOR
    );

  if (!checkbox) {
    return;
  }

  let button =
    offer.querySelector(
      '.madspeed7-add-item-button'
    );

  if (!button) {

    button =
      document.createElement('button');

    button.type =
      'button';

    button.className =
      'madspeed7-add-item-button';

    const inputsWrapper =
      offer.querySelector(
        INPUTS_WRAPPER_SELECTOR
      );

    if (inputsWrapper) {

      inputsWrapper.appendChild(
        button
      );

    } else {

      const info =
        offer.querySelector(
          '.candyrack-ppp-checkbox-layout__info'
        );

      if (info) {
        info.appendChild(button);
      }

    }
  }

  /*
   * -----------------------------------------
   * Restore our own selected state
   * -----------------------------------------
   */

  const isSelected =
    button.dataset.madspeed7Added === 'true';

  button.textContent =
    isSelected
      ? '✓ Added'
      : 'Add Item';

  /*
 * -----------------------------------------
 * Button styling
 * -----------------------------------------
 */

function updateButtonStyle() {

  const selected =
    button.dataset.madspeed7Added === 'true';

  button.style.display =
    'block';

  button.style.width =
    '100%';

  button.style.height =
    '44px';

  button.style.marginTop =
    '8px';

  button.style.cursor =
    'pointer';

  button.style.fontWeight =
    '600';

  button.style.fontSize =
    '14px';

  button.style.boxSizing =
    'border-box';

  if (selected) {

    button.style.background =
      '#222';

    button.style.color =
      '#fff';

    button.style.border =
      '1px solid #222';

  } else {

    button.style.background =
      '#fff';

    button.style.color =
      '#222';

    button.style.border =
      '1px solid #222';

  }
}

updateButtonStyle();

  /*
   * -----------------------------------------
   * Bind button once
   * -----------------------------------------
   */

  if (
    button.dataset.madspeed7Bound ===
    'true'
  ) {
    return;
  }

  button.dataset.madspeed7Bound =
    'true';

  button.addEventListener(
    'click',
    function (event) {

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      /*
       * -------------------------------------
       * Toggle selected state
       * -------------------------------------
       */

      const currentlySelected =
        button.dataset.madspeed7Added ===
        'true';

      if (currentlySelected) {

        /*
         * Deselect add-on
         */

        button.dataset.madspeed7Added =
          'false';

        button.textContent =
          'Add Item';
          updateButtonStyle();

        /*
         * Keep the Candy Rack checkbox
         * deselected internally.
         */

        if (checkbox.checked) {
          checkbox.checked = false;
        }

        return;
      }

      /*
       * -------------------------------------
       * Select add-on
       * -------------------------------------
       */

      const select =
        offer.querySelector(
          SELECTOR_SELECTOR
        );

      if (
        select &&
        (
          !select.value ||
          select.value ===
            '__cr_select_option__'
        )
      ) {

        console.log(
          'MADSPEED7 — Please select a variant first.'
        );

        return;
      }

      /*
       * Store the selected state.
       * The actual cart addition will happen
       * later when the main wheel Add to Cart
       * button is clicked.
       */

      button.dataset.madspeed7Added =
        'true';

      /*
       * Store the selected variant.
       */

      if (select) {

        button.dataset.madspeed7VariantId =
          String(select.value);

      } else {

        button.dataset.madspeed7VariantId =
          '';

      }

      /*
       * Store the selected quantity.
       */

      button.dataset.madspeed7Quantity =
        String(
          getQuantityFromOfferControl(
            offer
          )
        );

      button.textContent =
        '✓ Added';
        updateButtonStyle();

      console.log(
        'MADSPEED7 — Add-on selected:',
        {
          variantId:
            button.dataset.madspeed7VariantId,

          quantity:
            button.dataset.madspeed7Quantity
        }
      );

    }
  );
}


  /* =========================================================
     9. INITIALISE EACH OFFER
  ========================================================= */

  function initialiseOffers() {

    hideCheckboxGraphics();


    const offers =
      document.querySelectorAll(
        OFFER_SELECTOR
      );


    offers.forEach(
  function (offer) {

    createQuantityControl(
      offer
    );

    createAddItemButton(
      offer
    );

    setupVariantRequirement(
      offer
    );

    setupVariantPricing(
  offer
);

 createQuickViewLink(
  offer
);

removeCandyRackGBP();

  }
);

  }

  function removeCandyRackGBP() {

  document.querySelectorAll(
    '.candyrack-ppp-currency-output'
  ).forEach(function (element) {

    element.textContent =
      element.textContent.replace(
        /\s*GBP\s*$/i,
        ''
      );

  });

}


  function resetCandyRackAddons() {

  const offers =
    document.querySelectorAll(
      OFFER_SELECTOR
    );

  offers.forEach(
    function (offer) {

      const button =
        offer.querySelector(
          '.madspeed7-add-item-button'
        );

      const select =
        offer.querySelector(
          SELECTOR_SELECTOR
        );

      const quantity =
        offer.querySelector(
          '.madspeed7-addon-quantity'
        );


      /* Reset Add Item button */

      if (button) {

        button.dataset.madspeed7Added =
          'false';

        button.dataset.madspeed7VariantId =
          '';

        button.dataset.madspeed7Quantity =
          '1';

        button.textContent =
          'Add Item';

        button.style.background =
          '#ffffff';

        button.style.color =
          '#222222';

        button.style.borderColor =
          '#222222';

        button.style.opacity =
          '';

        button.style.cursor =
          'pointer';
      }


      /* Reset quantity to 1 */

      if (quantity) {

        quantity.dataset.quantity =
          '1';

        const value =
          quantity.querySelector(
            '.madspeed7-addon-qty-value'
          );

        const minus =
          quantity.querySelector(
            '.madspeed7-addon-qty-minus'
          );

        if (value) {
          value.textContent =
            '1';
        }

        if (minus) {
          minus.disabled =
            true;
        }
      }


      /* Reset variant selector */

      if (select) {

        select.value =
          '__cr_select_option__';

        select.selectedIndex =
          0;

        const handleLabel =
          offer.querySelector(
            '.styles_selectHandleLabel__7a9ea26'
          );

        if (handleLabel) {

          handleLabel.textContent =
            'Select option';
        }


        /* Disable Add Item again */

        if (button) {

          button.disabled =
            true;

          button.style.opacity =
            '0.45';

          button.style.cursor =
            'not-allowed';

          button.style.background =
            '#eeeeee';

          button.style.color =
            '#888888';

          button.style.borderColor =
            '#cccccc';
        }

      } else {

        /* No-variant products stay active */

        if (button) {

          button.disabled =
            false;

          button.style.opacity =
            '';

          button.style.cursor =
            'pointer';

          button.style.background =
            '#ffffff';

          button.style.color =
            '#222222';

          button.style.borderColor =
            '#222222';
        }
      }

    }
  );

}

  /* =========================================================
     10. OBSERVE CANDY RACK
  ========================================================= */

  function scheduleInitialisation() {

    clearTimeout(
      window.madspeed7CandyRackTimer
    );


    window.madspeed7CandyRackTimer =
  setTimeout(
    function () {

      initialiseOffers();

      setupMainProductAddToCart();

    },
    100
  );

    }


  document.addEventListener(
    'DOMContentLoaded',
    scheduleInitialisation
  );


  window.addEventListener(
    'load',
    scheduleInitialisation
  );


  const observer =
    new MutationObserver(
      function () {

        scheduleInitialisation();

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  console.log(
    'MADSPEED7 — Universal Candy Rack system ready.'
  );

  function setupMainProductAddToCart() {

  const form =
    document.querySelector(
      'form[action="/cart/add"].form'
    );

  if (!form) {
    console.log(
      'MADSPEED7 — Main product form not found.'
    );
    return;
  }

  const button =
    form.querySelector(
      'button[type="submit"][name="add"]'
    );

  if (!button) {
    console.log(
      'MADSPEED7 — Main Add to cart button not found.'
    );
    return;
  }

  if (
    button.dataset.madspeed7MainBound ===
    'true'
  ) {
    return;
  }

  button.dataset.madspeed7MainBound =
    'true';

  button.addEventListener(
    'click',
    async function(event) {

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      /*
       * Prevent double-clicks
       */

      if (
        button.dataset.madspeed7Adding ===
        'true'
      ) {
        return;
      }

      button.dataset.madspeed7Adding =
        'true';

      /*
       * =======================================
       * GET WHEEL VARIANT
       * =======================================
       */

      const wheelVariant =
        form.querySelector(
          'input[name="id"]'
        )?.value;

      /*
       * =======================================
       * GET WHEEL QUANTITY
       * =======================================
       */

      const wheelQuantity =
        parseInt(
          form.querySelector(
            'input[name="quantity"]'
          )?.value || '1',
          10
        ) || 1;

      if (!wheelVariant) {

        console.error(
          'MADSPEED7 — Wheel variant not found.'
        );

        button.dataset.madspeed7Adding =
          'false';

        return;
      }

      /*
       * =======================================
       * START WITH THE WHEEL
       * =======================================
       */

      const items = [
        {
          id: Number(wheelVariant),
          quantity: wheelQuantity
        }
      ];

      /*
       * =======================================
       * FIND SELECTED ADD-ONS
       * =======================================
       */

      const selectedAddons =
        Array.from(
          document.querySelectorAll(
            '.madspeed7-add-item-button[data-madspeed7-added="true"]'
          )
        );

      console.log(
        'MADSPEED7 — Selected add-ons:',
        selectedAddons.length
      );

      /*
       * =======================================
       * PROCESS EACH ADD-ON
       * =======================================
       */

      for (
        const addonButton of selectedAddons
      ) {

        const offer =
          addonButton.closest(
            '.candyrack-ppp-checkbox-layout__offer'
          );

        if (!offer) {

          console.warn(
            'MADSPEED7 — Add-on offer not found.'
          );

          continue;
        }

        /*
         * ---------------------------------------
         * Get quantity
         * ---------------------------------------
         */

        const quantity =
          parseInt(
            addonButton.dataset
              .madspeed7Quantity || '1',
            10
          ) || 1;

        /*
         * ---------------------------------------
         * Get stored variant ID
         * ---------------------------------------
         */

        let variantId =
          addonButton.dataset
            .madspeed7VariantId || '';

        /*
         * ---------------------------------------
         * If there is no variant ID,
         * this is a product with no variant
         * selector.
         *
         * Find its Shopify default variant
         * using the Candy Rack product ID.
         * ---------------------------------------
         */

        if (!variantId) {

          const productId =
            getCandyRackProductId(
              offer
            );

          console.log(
            'MADSPEED7 — No variant selected. Product ID:',
            productId
          );

          if (!productId) {

            console.error(
              'MADSPEED7 — Cannot find product ID for add-on.'
            );

            continue;
          }

          variantId =
            await getDefaultVariantId(
              productId
            );

          if (!variantId) {

            console.error(
              'MADSPEED7 — Could not find default variant for product:',
              productId
            );

            continue;
          }

          /*
           * Store it so the next time this
           * add-on is used we already know it.
           */

          addonButton.dataset
            .madspeed7VariantId =
              String(variantId);

        }

        /*
         * ---------------------------------------
         * Add the add-on to the same cart
         * request as the wheel.
         * ---------------------------------------
         */

        items.push({
          id: Number(variantId),
          quantity: quantity
        });

        console.log(
          'MADSPEED7 — Add-on added to request:',
          {
            productId:
              getCandyRackProductId(
                offer
              ),
            variantId:
              variantId,
            quantity:
              quantity
          }
        );

      }

      /*
       * =======================================
       * DEBUG
       * =======================================
       */

      console.log(
        '================================='
      );

      console.log(
        'MADSPEED7 — FINAL CART REQUEST'
      );

      console.log(
        'Wheel:',
        wheelVariant,
        'Quantity:',
        wheelQuantity
      );

      console.log(
        'Selected add-ons:',
        selectedAddons.length
      );

      console.log(
        'Items:',
        items
      );

      console.log(
        '================================='
      );

      /*
       * =======================================
       * ADD EVERYTHING IN ONE REQUEST
       * =======================================
       */

      try {

        const response =
          await fetch(
            '/cart/add.js',
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                'Accept':
                  'application/json'
              },

              body:
                JSON.stringify({
                  items: items
                })
            }
          );

        if (!response.ok) {

          throw new Error(
            'Cart add failed: HTTP ' +
            response.status
          );

        }

        const data =
          await response.json();

        console.log(
          'MADSPEED7 — FINAL CART SUCCESS:',
          data
        );

        /*
         * =======================================
         * VERIFY ACTUAL CART
         * =======================================
         */

        const cartResponse =
          await fetch(
            '/cart.js',
            {
              headers: {
                'Accept':
                  'application/json'
              }
            }
          );

        const cart =
          await cartResponse.json();

        console.log(
          'MADSPEED7 — CART AFTER ADD:',
          cart.items.map(
            function(item) {

              return {
                title:
                  item.product_title,

                variant:
                  item.variant_title,

                quantity:
                  item.quantity,

                variantId:
                  item.variant_id
              };

            }
          )
        );

        /*
         * =======================================
         * TELL DAWN CART HAS UPDATED
         * =======================================
         */

        document.dispatchEvent(
          new CustomEvent(
            'madspeed7:cart-updated'
          )
        );
        resetCandyRackAddons();

        /*
         * =======================================
         * REFRESH CART DRAWER
         * =======================================
         */

        const cartDrawer =
          document.querySelector(
            'cart-drawer'
          );

        if (
          cartDrawer &&
          typeof cartDrawer.renderContents ===
            'function'
        ) {

          try {

            const sectionsResponse =
              await fetch(
                '/?sections=cart-drawer,cart-icon-bubble'
              );

            const sections =
              await sectionsResponse.json();

            /*
             * -----------------------------------
             * Update cart drawer
             * -----------------------------------
             */

            if (
              sections['cart-drawer']
            ) {

              const parser =
                new DOMParser();

              const drawerDocument =
                parser.parseFromString(
                  sections['cart-drawer'],
                  'text/html'
                );

              const newDrawer =
                drawerDocument.querySelector(
                  'cart-drawer'
                );

              if (newDrawer) {

                cartDrawer.innerHTML =
                  newDrawer.innerHTML;

              }

            }

            /*
             * -----------------------------------
             * Update cart icon
             * -----------------------------------
             */

            if (
              sections['cart-icon-bubble']
            ) {

              const bubble =
                document.querySelector(
                  '#cart-icon-bubble'
                );

              const bubbleParser =
                new DOMParser();

              const bubbleDocument =
                bubbleParser.parseFromString(
                  sections['cart-icon-bubble'],
                  'text/html'
                );

              const newBubble =
                bubbleDocument.querySelector(
                  '#cart-icon-bubble'
                );

              if (
                bubble &&
                newBubble
              ) {

                bubble.innerHTML =
                  newBubble.innerHTML;

              }

            }

          } catch (drawerError) {

            console.warn(
              'MADSPEED7 — Cart drawer refresh failed:',
              drawerError
            );

          }

          /*
           * =====================================
           * OPEN DRAWER AFTER EVERYTHING
           * HAS BEEN ADDED
           * =====================================
           */

          if (
            typeof cartDrawer.open ===
              'function'
          ) {

            cartDrawer.open();

          }

        }

      } catch (error) {

        console.error(
          'MADSPEED7 — FINAL CART FAILED:',
          error
        );

      }

      /*
       * =======================================
       * RELEASE BUTTON
       * =======================================
       */

      button.dataset.madspeed7Adding =
        'false';

    },
    true
  );

}

/* =========================================================
   MADSPEED7 CANDY RACK SLIDER
   Desktop = 2 cards
   Mobile = 1 card
========================================================= */

(function () {

  function createChevron(direction) {

    const svgNS =
      'http://www.w3.org/2000/svg';

    const svg =
      document.createElementNS(
        svgNS,
        'svg'
      );

    svg.setAttribute(
      'viewBox',
      '0 0 24 24'
    );

    const path =
      document.createElementNS(
        svgNS,
        'path'
      );

    if (direction === 'prev') {

      path.setAttribute(
        'd',
        'M14.5 6.5L9 12l5.5 5.5'
      );

    } else {

      path.setAttribute(
        'd',
        'M9.5 6.5L15 12l-5.5 5.5'
      );

    }

    path.setAttribute(
      'fill',
      'none'
    );

    path.setAttribute(
      'stroke',
      'currentColor'
    );

    path.setAttribute(
  'stroke-width',
  '2'
);

    path.setAttribute(
      'stroke-linecap',
      'round'
    );

    path.setAttribute(
      'stroke-linejoin',
      'round'
    );

    svg.appendChild(path);

    return svg;

  }


  function createSliderNav(
    header,
    list
  ) {

    if (!header || !list) {
      return;
    }

    /*
     * Don't create the arrows twice.
     */

    if (
      header.querySelector(
        '.madspeed7-candyrack-nav'
      )
    ) {
      return;
    }

    /*
     * -----------------------------------------
     * Navigation wrapper
     * -----------------------------------------
     */

    const nav =
      document.createElement(
        'div'
      );

    nav.className =
      'madspeed7-candyrack-nav';


    /*
     * -----------------------------------------
     * Previous button
     * -----------------------------------------
     */

    const prev =
      document.createElement(
        'button'
      );

    prev.type =
      'button';

    prev.className =
      'madspeed7-candyrack-prev';

    prev.setAttribute(
      'aria-label',
      'Previous offers'
    );

    prev.appendChild(
      createChevron('prev')
    );


    /*
     * -----------------------------------------
     * Next button
     * -----------------------------------------
     */

    const next =
      document.createElement(
        'button'
      );

    next.type =
      'button';

    next.className =
      'madspeed7-candyrack-next';

    next.setAttribute(
      'aria-label',
      'Next offers'
    );

    next.appendChild(
      createChevron('next')
    );


    nav.appendChild(prev);
    nav.appendChild(next);

    header.appendChild(nav);


    let isAnimating =
      false;

    let animTimer =
      null;


    /*
     * -----------------------------------------
     * Get cards
     * -----------------------------------------
     */

    function getCards() {

      return Array.from(
        list.querySelectorAll(
          '.candyrack-ppp-checkbox-layout__offer'
        )
      );

    }


    /*
     * -----------------------------------------
     * Maximum scroll
     * -----------------------------------------
     */

    function getMaxScroll() {

      return Math.max(
        0,
        Math.round(
          list.scrollWidth -
          list.clientWidth
        )
      );

    }


    /*
     * -----------------------------------------
     * Current scroll
     * -----------------------------------------
     */

    function getCurrentScroll() {

      return Math.round(
        list.scrollLeft
      );

    }


    /*
     * -----------------------------------------
     * Cards per arrow press
     * -----------------------------------------
     */

    function getStepSize() {

      return window.innerWidth <= 749
        ? 1
        : 2;

    }


    /*
     * -----------------------------------------
     * Calculate card positions
     * -----------------------------------------
     */

    function getSnapPoints() {

      const cards =
        getCards();

      const maxScroll =
        getMaxScroll();

      return Array.from(

        new Set(

          cards.map(
            function (card) {

              const point =
                Math.round(
                  card.offsetLeft -
                  list.offsetLeft
                );

              return Math.max(
                0,
                Math.min(
                  point,
                  maxScroll
                )
              );

            }
          )

        )

      ).sort(
        function (a, b) {
          return a - b;
        }
      );

    }


    /*
     * -----------------------------------------
     * Find nearest card position
     * -----------------------------------------
     */

    function getClosestPointIndex() {

      const points =
        getSnapPoints();

      const current =
        getCurrentScroll();

      let closestIndex =
        0;

      let closestDistance =
        Infinity;

      points.forEach(
        function (
          point,
          index
        ) {

          const distance =
            Math.abs(
              point -
              current
            );

          if (
            distance <
            closestDistance
          ) {

            closestDistance =
              distance;

            closestIndex =
              index;

          }

        }
      );

      return closestIndex;

    }


    /*
     * -----------------------------------------
     * Enable / disable arrows
     * -----------------------------------------
     */

    function updateButtons() {

      const current =
        getCurrentScroll();

      const maxScroll =
        getMaxScroll();

      const tolerance =
        4;

      prev.disabled =
        current <=
        tolerance;

      next.disabled =
        current >=
        maxScroll -
        tolerance;

    }


    /*
     * -----------------------------------------
     * Scroll to position
     * -----------------------------------------
     */

    function scrollToPoint(
      target
    ) {

      isAnimating =
        true;

      const finalTarget =
        Math.max(
          0,
          Math.min(
            Math.round(target),
            getMaxScroll()
          )
        );

      list.scrollTo({

        left:
          finalTarget,

        behavior:
          'smooth'

      });

      clearTimeout(
        animTimer
      );

      animTimer =
        setTimeout(
          function () {

            isAnimating =
              false;

            updateButtons();

          },
          350
        );

    }


    /*
     * -----------------------------------------
     * NEXT
     * -----------------------------------------
     */

    function goNext() {

      if (isAnimating) {
        return;
      }

      const points =
        getSnapPoints();

      if (!points.length) {
        return;
      }

      const currentIndex =
        getClosestPointIndex();

      const step =
        getStepSize();

      const targetIndex =
        Math.min(
          currentIndex +
          step,
          points.length - 1
        );

      scrollToPoint(
        points[targetIndex]
      );

    }


    /*
     * -----------------------------------------
     * PREVIOUS
     * -----------------------------------------
     */

    function goPrev() {

      if (isAnimating) {
        return;
      }

      const points =
        getSnapPoints();

      if (!points.length) {
        return;
      }

      const currentIndex =
        getClosestPointIndex();

      const step =
        getStepSize();

      const targetIndex =
        Math.max(
          currentIndex -
          step,
          0
        );

      scrollToPoint(
        points[targetIndex]
      );

    }


    prev.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        goPrev();

      }
    );


    next.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        goNext();

      }
    );


    /*
     * -----------------------------------------
     * Update arrows while scrolling
     * -----------------------------------------
     */

    list.addEventListener(
      'scroll',
      function () {

        updateButtons();

      },
      {
        passive: true
      }
    );


    /*
     * -----------------------------------------
     * Update after resize
     * -----------------------------------------
     */

    window.addEventListener(
      'resize',
      function () {

        isAnimating =
          false;

        clearTimeout(
          animTimer
        );

        updateButtons();

      }
    );


    /*
     * -----------------------------------------
     * Initial state
     * -----------------------------------------
     */

    setTimeout(
      updateButtons,
      100
    );

    setTimeout(
      updateButtons,
      400
    );

    setTimeout(
      updateButtons,
      800
    );

  }


  function initCheckboxSlider() {

    const block =
      document.querySelector(
        '#offers-layout-block'
      );

    if (!block) {
      return;
    }

    const header =
      block.querySelector(
        '.candyrack-ppp-checkbox-layout__offers'
      );

    const list =
      block.querySelector(
        '.candyrack-ppp-checkbox-layout__offers--list'
      );

    if (
      !header ||
      !list
    ) {
      return;
    }

    createSliderNav(
      header,
      list
    );

  }


  /*
   * -----------------------------------------
   * Initialise
   * -----------------------------------------
   */

  document.addEventListener(
    'DOMContentLoaded',
    initCheckboxSlider
  );

  window.addEventListener(
    'load',
    initCheckboxSlider
  );


  /*
   * -----------------------------------------
   * Candy Rack loads dynamically,
   * so watch for it.
   * -----------------------------------------
   */

  const observer =
    new MutationObserver(
      function () {

        initCheckboxSlider();

      }
    );

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  setTimeout(
    initCheckboxSlider,
    400
  );

  setTimeout(
    initCheckboxSlider,
    1200
  );

})();

/* =========================================================
   MADSPEED7 — SIMPLE QUICK VIEW POPUP
   Image + Title + Description + Close
========================================================= */

(function () {

  function createQuickViewPopup(offer) {

  if (
    document.querySelector(
      '.madspeed7-candyrack-qv-modal'
    )
  ) {
    return;
  }

  /* -----------------------------------------
     Get Candy Rack product ID
     ----------------------------------------- */

  const productId =
    getCandyRackProductId(
      offer
    );

  if (!productId) {
    console.error(
      'MADSPEED7 — Quick View product ID not found.'
    );
    return;
  }

  /* -----------------------------------------
     Create popup
     ----------------------------------------- */

  const overlay =
    document.createElement(
      'div'
    );

  overlay.className =
  'madspeed7-candyrack-qv-modal';


  const box =
    document.createElement(
      'div'
    );

  box.className =
    'madspeed7-qv-box';


  const close =
    document.createElement(
      'button'
    );

  close.type =
    'button';

  close.className =
    'madspeed7-qv-close';

  close.setAttribute(
    'aria-label',
    'Close'
  );

  close.textContent =
    '×';


  const imageWrap =
    document.createElement(
      'div'
    );

  imageWrap.className =
    'madspeed7-qv-image';


  const image =
    document.createElement(
      'img'
    );

  image.alt = '';


  const content =
    document.createElement(
      'div'
    );

  content.className =
    'madspeed7-qv-content';


  const title =
    document.createElement(
      'div'
    );

  title.className =
    'madspeed7-qv-title';


  const description =
    document.createElement(
      'div'
    );

  description.className =
    'madspeed7-qv-description';


  imageWrap.appendChild(
    image
  );

  content.appendChild(
    title
  );

  content.appendChild(
    description
  );


  /* =========================================================
   MADSPEED7 — CANDY RACK QUICK VIEW CLOSE BUTTON
   Keep close button outside the scrolling Quick View box
   ========================================================= */

const closeWrapper =
  document.createElement(
    'div'
  );

closeWrapper.className =
  'madspeed7-qv-close-wrapper';

closeWrapper.appendChild(
  close
);

box.appendChild(
  imageWrap
);

box.appendChild(
  content
);

closeWrapper.appendChild(
  box
);

overlay.appendChild(
  closeWrapper
);

  document.body.appendChild(
    overlay
  );
  const originalBodyOverflow =
  document.body.style.overflow;

document.body.style.overflow =
  'hidden';


  /* -----------------------------------------
     Show popup immediately
     ----------------------------------------- */

  overlay.style.display =
    'flex';


  /* -----------------------------------------
     Load actual Shopify product
     ----------------------------------------- */

  window.madspeed7ProductsPromise.then(
  function (data) {
    return {
      ok: true,
      json: function () {
        return Promise.resolve(data);
      }
    };
  }
)
    .then(
      function (response) {

        if (!response.ok) {
          throw new Error(
            'Product lookup failed: HTTP ' +
            response.status
          );
        }

        return response.json();

      }
    )
    .then(
      function (data) {

        const product =
          (data.products || []).find(
            function (item) {

              return String(item.id) ===
                String(productId);

            }
          );


        if (!product) {

          console.error(
            'MADSPEED7 — Quick View product not found:',
            productId
          );

          return;
        }


        /* -----------------------------------
           Real Shopify product title
           ----------------------------------- */

        title.textContent =
          product.title || '';


        /* -----------------------------------
           Real Shopify product description
           ----------------------------------- */

        description.innerHTML =
          product.body_html || '';


        /* -----------------------------------
           Real Shopify product image
           ----------------------------------- */

        if (
  product.images &&
  product.images.length
) {

  image.src =
    product.images[0].src;

  image.alt =
    product.title || '';

}

      }
    )
    .catch(
      function (error) {

        console.error(
          'MADSPEED7 — Quick View failed:',
          error
        );

      }
    );


  /* -----------------------------------------
     Close popup
     ----------------------------------------- */

  function closePopup() {

  document.body.style.overflow =
    originalBodyOverflow;

  overlay.remove();

}


  close.addEventListener(
    'click',
    closePopup
  );


  overlay.addEventListener(
    'click',
    function (event) {

      if (
        event.target ===
        overlay
      ) {

        closePopup();

      }

    }
  );

}


  document.addEventListener(
    'click',
    function (event) {

      const quickView =
        event.target.closest(
          '.madspeed7-quick-view'
        );

      if (!quickView) {
        return;
      }

      const offer =
        quickView.closest(
          '.candyrack-ppp-checkbox-layout__offer'
        );

      if (!offer) {
        return;
      }

      event.preventDefault();

      createQuickViewPopup(
        offer
      );

    }
  );


  window.madspeed7OpenQuickView =
    createQuickViewPopup;

})();


})();